import cx from 'classnames';
import { EditorState, RichUtils } from 'draft-js';

import Icon from 'components/shared/Icon';
import OrderedListIcon from 'components/shared/Icon/icons/OrderedList';
import UnOrderedListIcon from 'components/shared/Icon/icons/UnOrderedList';
import { useWysiwygContext } from 'components/shared/Wysiwyg/Wysiwyg.contex';

import { BaseItemButton } from '../Base';
import s from './List.module.css';

type Props = {
  type: 'unordered-list-item' | 'ordered-list-item';
};

const List = (props: Props) => {
  const { editor } = useWysiwygContext();
  const icon = props.type === 'ordered-list-item' ? OrderedListIcon : UnOrderedListIcon;

  const onClick = () => {
    editor.handleChange(RichUtils.toggleBlockType(editor.editorState, props.type));
  };

  const isActive = getCurrentBlockType(editor.editorState) === props.type;

  return (
    <BaseItemButton onClick={onClick} className={cx(isActive && s.active)}>
      <Icon component={icon} />
    </BaseItemButton>
  );
};

const getCurrentBlockType = (editorState: EditorState): string => {
  const selectionState = editorState.getSelection();
  const contentState = editorState.getCurrentContent();
  const blockKey = selectionState.getStartKey();

  return contentState.getBlockForKey(blockKey).getType();
};

export const OrderedList = () => <List type="ordered-list-item" />;
export const UnorderedList = () => <List type="unordered-list-item" />;
